import React, { ReactNode } from "react";
import { useScrollTrigger } from "@material-ui/core";
import styled from "styled-components/macro";

interface HideOnScrollContainerProps {
  children: ReactNode;
  target?: HTMLElement; // Scroll container - leave blank to use window
  height?: number; // Fixed height of the children area - allows for a better hide
  allowHide?: boolean; // Decides when to allow hide on scroll
  disableHysteresis?: boolean; // Decides whether to provide a buffer for the scroll - Set to false by default to trigger instantly
}

interface TransitionContainerProps {
  hide: boolean;
  height?: number;
}

const TransitionContainer = styled.div<TransitionContainerProps>`
  ${({ hide, height = 50 }) => `
    transform: translateY(${hide ? `-${height}px` : "0"});
    height: ${hide ? "0px" : `${height}px`};
    transition: transform 0.3s ease-in-out, height 0.3s ease-in-out;
    overflow: ${hide ? "hidden" : "visible"};
    will-change: transform, height;
  `}
`;

const HideOnScrollContainer = ({
  children,
  target,
  height,
  allowHide = true,
  disableHysteresis = true,
}: HideOnScrollContainerProps) => {
  const triggerHide = useScrollTrigger({
    target: target || undefined, // undefined defaults to window :)
    disableHysteresis,
  });

  return (
    <TransitionContainer hide={!!allowHide && !!triggerHide} height={height}>
      {children}
    </TransitionContainer>
  );
};

export default HideOnScrollContainer;
